import { render, staticRenderFns } from "./ExportConfirm.vue?vue&type=template&id=04d60c9e"
import script from "./ExportConfirm.vue?vue&type=script&lang=js"
export * from "./ExportConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports